import axios from 'axios';
import { ENV_CONFIG } from '../../../config/config';

export const validadordeDerechoApi = (tokenAutorizacion:any) => axios.create({
    baseURL: `${ENV_CONFIG.VALIDADOR_DE_DERECHO_URL}`,
    headers: {
        'Authorization': 'Bearer ' + tokenAutorizacion,
    }
});